module.exports = __webpack_public_path__ + "44fed91f69f09c95876314a8e23f311e.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ushahidi-platform-pattern-library/assets/img/iconic-sprite.svg
// module id = 412
// module chunks = 0